import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import { useEffect, useMemo, useState } from 'react';
import styles from './index.module.scss';

const productIdObj = {
    jp: 14692433133935,
};

export default function Comp() {
    const { t } = useLang('theProduct.BannerB');
    const { locale = 'us' } = getLocal();
    const IS_JP_SITE = locale === 'jp';
    const IS_AU_SITE = locale === 'au';
    const IS_EU_SITE = ['us', 'ca'].includes(locale);
    const isEU = ['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale);

    const buynow = useMemo(() => {
        switch (locale) {
            case 'us':
                return 'https://us.ecoflow.com/products/ecoflow-wave-3-portable-air-conditioner-with-heater';
            case 'ca':
                return 'https://ca.ecoflow.com/products/ecoflow-wave-3-portable-air-conditioner-with-heater';
            case 'eu':
            case 'uk':
            case 'de':
            case 'fr':
            case 'it':
            case 'es':
                return `https://${locale}.ecoflow.com/products/wave-3-portable-air-conditioner`;
            case 'au':
                return 'https://au.ecoflow.com/products/ecoflow-wave-3-portable-air-conditioner';
            default:
                return '#';
        }
    }, [locale]);

    const dataA: EcoBannerProps = {
        layout: 'top-center',
        pc: IS_JP_SITE
            ? 'https://websiteoss.ecoflow.com/upload/image/1745313558521/KV.jpg'
            : 'https://websiteoss.ecoflow.com/upload/image/1744783701457/pc.jpg',
        pad: IS_JP_SITE
            ? 'https://websiteoss.ecoflow.com/upload/image/1745313558737/KV-h5.jpg'
            : 'https://websiteoss.ecoflow.com/upload/image/1744783701457/pc.jpg',
        h5: IS_JP_SITE
            ? 'https://websiteoss.ecoflow.com/upload/image/1745313558737/KV-h5.jpg'
            : 'https://websiteoss.ecoflow.com/upload/image/1744783682065/h5.jpg',
        label: isEU ? '' : t('label'),
        title: t('title'),
        subTitle: t('subTitle'),
        desc: t('desc'),

        theme: 'white',
        lChildren: t('buynow'),
        lHref: IS_JP_SITE ? 'https://jp.ecoflow.com/cart/51919145959791:1?channel=buy_button' : buynow,
        lType: 'filled',
        rChildren: t('video'),
        rHref: IS_JP_SITE
            ? 'https://www.youtube.com/embed/G7FoL0pMUU4'
            : IS_EU_SITE
            ? 'https://www.youtube.com/embed/Hk8s6vCQ3gA'
            : 'https://www.youtube.com/embed/Hk8s6vCQ3gA',
        rType: 'outlined',
        rBtnIsYouToBe: true,
    };

    const [bannerHeight, setBannerHeight] = useState(800);
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const callback = () => {
                const { height = 0 } = document.querySelector('.ecoflow-frame-header')?.getBoundingClientRect() ?? {};
                const { height: navHeight = 0 } = document.querySelector('.eco-nav-product')?.getBoundingClientRect() ?? {};
                // @ts-ignore
                setBannerHeight(window.innerHeight - height - navHeight);
            };
            if (window.innerWidth < 1024) {
                setTimeout(() => {
                    callback();
                }, 0);
            } else {
                callback();
                window.addEventListener('resize', callback);
                return () => window.removeEventListener('resize', callback);
            }
        }
    }, []);
    return (
        // @ts-ignore
        <div className={styles.comp} style={{ '--banner-height': `${bannerHeight}px` }}>
            <EcoBanner {...dataA} />
        </div>
    );
}
